import React from 'react';

const OrderInvoice = React.forwardRef(({ orderData, logo }, ref) => {
    if (!orderData) return null;

    const { 
        shippingAddress, 
        order_number, 
        order_date, 
        final_amount_INR, 
        payment_method_name, 
        shipments 
    } = orderData;

    const items = shipments?.[0]?.items || [];

    return (
        <div style={{ display: 'none' }}>
            <div ref={ref} className="print-label">
                <style>{`
                    @media print {
                        @page { size: 4in 6in; margin: 0; }
                        body { margin: 0; padding: 0; font-family: sans-serif; }
                        .print-label { width: 4in; height: 6in; padding: 5mm; box-sizing: border-box; display: flex; flex-direction: column; background: white; }
                        .border-box { border: 1pt solid black; height: 100%; display: flex; flex-direction: column; }
                    }
                    .header { border-bottom: 1pt solid black; padding: 5px; text-align: center; display: flex; flex-direction: column; align-items: center; }
                    .logo-img { width: 120px; height: auto; margin-bottom: 4px; }
                    .address-section { border-bottom: 1pt solid black; padding: 5px; font-size: 10px; }
                    .items-table { width: 100%; border-collapse: collapse; flex-grow: 1; margin-top: 5px; }
                    .items-table th { border-bottom: 1pt solid black; font-size: 9px; text-align: left; padding: 2px; }
                    .items-table td { font-size: 9px; padding: 4px 2px; border-bottom: 0.5pt solid #eee; vertical-align: top; }
                    .footer { border-top: 1pt solid black; padding: 5px; font-size: 10px; }
                    .bold { font-weight: bold; }
                    .text-right { text-align: right; }
                `}</style>

                <div className="border-box">
                    {/* Header with Logo */}
                    <div className="header">
                        {logo && <img src={logo} alt="Logo" className="logo-img" />}
                        <div className="bold" style={{ fontSize: '12px' }}>TAX INVOICE</div>
                        <div style={{ fontSize: '9px' }}>{order_number}</div>
                    </div>

                    {/* Shipping Address */}
                    <div className="address-section">
                        <div className="bold" style={{ fontSize: '8px', marginBottom: '2px' }}>SHIP TO:</div>
                        <div className="bold">{shippingAddress.shipping_full_name}</div>
                        <div>{shippingAddress.shipping_address_line1}</div>
                        <div>{shippingAddress.shipping_city}, {shippingAddress.shipping_state_name} - {shippingAddress.shipping_pincode}</div>
                        <div className="bold">Mob: {shippingAddress.shipping_mobile_no}</div>
                    </div>

                    {/* Items List */}
                    <div style={{ padding: '5px', flexGrow: 1 }}>
                        <table className="items-table">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th className="text-right">Qty</th>
                                    <th className="text-right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((item, idx) => (
                                    <tr key={idx}>
                                        <td>
                                            <div className="bold">{item.product_name.split('|')[0]}</div>
                                            <div style={{ fontSize: '7px' }}>Color: {item.color_name}</div>
                                        </td>
                                        <td className="text-right">{item.quantity}</td>
                                        <td className="text-right">{item.final_amount_INR}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Summary Footer */}
                    <div className="footer">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span>Payment: <span className="bold">{payment_method_name}</span></span>
                            <span>Total: <span className="bold" style={{ fontSize: '14px' }}>{final_amount_INR}</span></span>
                        </div>
                        <div style={{ textAlign: 'center', fontSize: '7px', marginTop: '5px' }}>
                            Date: {new Date(order_date).toLocaleDateString()} | Thank you for your order!
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default OrderInvoice;